import * as React from "react";

interface UploadRowError {
  rowNumber: number;
  messages: string[];
}

interface UploadRowErrorsProps {
  errors: UploadRowError[] | null | undefined;
}

export function UploadRowErrors({ errors }: UploadRowErrorsProps) {
  if (!errors || errors.length === 0) return null;

  return (
    <div
      className="mt-4 p-4 bg-red-100 border border-red-400 rounded-md max-h-[150px] overflow-y-auto
        [&::-webkit-scrollbar]:w-2
        [&::-webkit-scrollbar]:bg-gray-100
        [&::-webkit-scrollbar-thumb]:bg-gray-400
        [&::-webkit-scrollbar-thumb]:rounded-full
        [&::-webkit-scrollbar-thumb]:border-2
        [&::-webkit-scrollbar-thumb]:border-gray-100"
    >
      {errors.map((row) => (
        <p key={row.rowNumber}>
          On Row {row.rowNumber}: {row.messages.join(", ")}
        </p>
      ))}
    </div>
  );
}
